interface ProgressIndicatorProps {
  currentStep: number;
  totalSteps: number;
  steps: string[];
}

export default function ProgressIndicator({
  currentStep,
  totalSteps,
  steps,
}: ProgressIndicatorProps) {
  return (
    <div className="w-full mb-8">
      <div className="flex items-center justify-between mb-4">
        {steps.map((step, index) => (
          <div key={index} className="flex items-center flex-1">
            <div className="flex flex-col items-center">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-heading font-semibold text-sm transition-all duration-300 ${
                  index + 1 <= currentStep
                    ? 'bg-accent text-white' :'bg-muted text-muted-foreground'
                }`}
              >
                {index + 1}
              </div>
              <span
                className={`mt-2 text-xs font-medium text-center ${
                  index + 1 <= currentStep ? 'text-accent' : 'text-muted-foreground'
                }`}
              >
                {step}
              </span>
            </div>
            {index < totalSteps - 1 && (
              <div className="flex-1 h-0.5 mx-2 bg-muted">
                <div
                  className={`h-full transition-all duration-300 ${
                    index + 1 < currentStep ? 'bg-accent' : 'bg-transparent'
                  }`}
                  style={{ width: index + 1 < currentStep ? '100%' : '0%' }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}